import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createPlan: {
		id: 'navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.create-plan-menu-button.create-plan',
		defaultMessage: 'Create plan',
		description: 'Description for the create plan menu item',
	},
});
